import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from 'components/move-list/components/context-menu/config/context-menu-action-names';
import { MoveList } from 'chessboard/model/move-list/types';
import { Core } from 'chessboard/core/config/types';
import { createCoreEvent } from 'chessboard/core/model/create-core-event';

/**
 * Create set focus node limit action
 */
export function createSetEnd(store: Store, storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.SetEnd,
    action: CONTEXT_MENU_ACTION_NAMES.SetEnd,
    isVisible,
    handler,
  };

  /**
   * Determine if the action is visible
   */
  function isVisible({ node }: ContextMenu.ActionHandlerContext): boolean {
    const { enabled, end } = store.nodeLimits.get();

    return enabled && end !== node.ids;
  }

  /**
   * Handle the action
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext) {
    const nodeLimit = { end: node.ids };
    const event = createCoreEvent(Core.APIEvents.NodeLimitsUpdated, nodeLimit);

    game.emit(Core.APIEvents.NodeLimitsUpdated, event);
    storeActions.setNodeLimits(nodeLimit);
  }
}
